import { render, staticRenderFns } from "./CustomerAccountsDetail.vue?vue&type=template&id=2d0dca30&scoped=true"
import script from "./CustomerAccountsDetail.vue?vue&type=script&lang=js"
export * from "./CustomerAccountsDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerAccountsDetail.vue?vue&type=style&index=0&id=2d0dca30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0dca30",
  null
  
)

export default component.exports